/* @flow */

import React, { Component } from 'react';
import $ from 'jquery';
import {
  HashRouter as Router,
  NavLink,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { connect } from 'react-redux';
import { Segment, Menu } from 'semantic-ui-react';
import * as CalendarActions from './actions';
import ImagesCard from './components/ImagesCard';
import QuestionsCard from './components/QuestionsCard';
import DiffusionCard from './components/DiffusionCard';

type Props = {
  loadInitialDatas: () => void,
};

type State = {
  showValidationErrors: boolean,
};

class Edit extends Component<Props, State> {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      showValidationErrors: false,
    };
  }

  componentDidMount() {
    this.props.loadInitialDatas();

    $('#invalid-form-icon .button').on('click', () =>
      this.setState({
        showValidationErrors: true,
      })
    );
  }

  render() {
    const { showValidationErrors } = this.state;

    return (
      <Router>
        <div>
          <Segment attached>
            <Menu secondary>
              <NavLink
                exact
                to="/images"
                activeClassName="active"
                className="item"
              >
                Images
              </NavLink>
              <NavLink
                exact
                to="/questions"
                activeClassName="active"
                className="item"
              >
                Questions
              </NavLink>
              <NavLink
                exact
                to="/diffusion"
                activeClassName="active"
                className="item"
              >
                Diffusion
              </NavLink>
            </Menu>
          </Segment>
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/images" />} />
            <Route exact path="/images">
              <ImagesCard />
            </Route>
            <Route exact path="/questions">
              <QuestionsCard showValidationErrors={showValidationErrors} />
            </Route>
            <Route exact path="/diffusion">
              <DiffusionCard />
            </Route>
          </Switch>
        </div>
      </Router>
    );
  }
}

export default connect(state => state, {
  loadInitialDatas: CalendarActions.loadInitialDatas,
})(Edit);



// WEBPACK FOOTER //
// ./src/modules/survey/Edit.js